import React, { useEffect } from 'react';
import styles from './header.module.scss';
import { actions } from '../../state';
import { connect } from 'react-redux';
import Logo from '../../images/logo.png';
import { checkBOPage } from '../../utils/helpers/helpers';
import { config, isTest } from './../../api/config';
import { isProd } from '../../api/config';
import { removeLocalStorageItem } from '../../utils';

const Header = ({ dispatch, generalData }) => {
  const goToMainWindow = () => {
    removeLocalStorageItem('boFilter');

    const isBO = checkBOPage();

    if (isProd()) {
      window.location.href = isBO
        ? 'https://paslaugos.ilte.lt/backoffice/main'
        : 'https://paslaugos.ilte.lt/platform';
      return;
    }

    if (isTest()) {
      window.location.href = isBO
        ? 'https://barzda-test.ilte.lt/backoffice/main'
        : 'https://barzda-test.ilte.lt/platform';
      return;
    }

    window.location.href = isBO
      ? 'https://barzda.scorify.lt/backoffice/main'
      : 'https://barzda.scorify.lt/platform';
  };

  //useEffect(() => {
  //  dispatch(actions.dashboard.loadGeneralDataAction());
  //}, [dispatch]);

  const logout = () => {
    dispatch(actions.auth.clearUserAction());
  };

  // useEffect(() => {
  //  dispatch(actions.dashboard.loadGeneralDataAction());
  // }, []);

  return (
    <div className={styles.container}>
      <div className="container">
        <div className="row header-flext-align">
          <div className="col-lg-8 col-sm-12">
            <a href={config.APP_PATHS.requests} className="logo-menu">
              <img src={Logo} alt="logo" />
            </a>

            {/*} <Link to={'/about'} className="menu-align-all">
              Apie projektą
  </Link>
            <Link to={'/description'} className="menu-align-all">
              Priemonių aprašymai
            </Link>*/}
            {
              // <span className="menu-align-all">
              //   <span className=""> Pasirašytų sutarčių suma: </span>
              //   <span className="bold">
              //     {' '}
              //     {formatNumber(generalData.ReservedSum)} EUR{' '}
              //   </span>
              //   iš
              //   <span className="bold">
              //     {' '}
              //     {formatNumber(generalData.TotalSum)} EUR{' '}
              //   </span>
              //   <br />
              //   <span className=""> Pasirašytų sutarčių suma: </span>
              //   <span className="bold">
              //     {' '}
              //     {formatNumber(generalData.ReservedSum)} EUR{' '}
              //   </span>
              //   iš
              //   <span className="bold">
              //     {' '}
              //     {formatNumber(generalData.TotalSum)} EUR{' '}
              //   </span>
              // </span>
            }
          </div>
          <div
            className="col-lg-4 col-sm-12 header-align-right"
            style={{ display: 'flex' }}
          >
            <div
              className={styles.headerButtonsContainer}
              style={{ marginRight: '15px' }}
            >
              <button
                className="btn btn-cap logout"
                style={{
                  width: '180px',
                  backgroundColor: 'rgb(0, 159, 227)',
                  border: 'rgb(0, 159, 227)',
                }}
                onClick={() => goToMainWindow()}
              >
                <span className="btn-text">
                  <span className="btn-icon-text">
                    <span>Priemonių sąrašas</span>
                  </span>
                </span>
              </button>
            </div>
            <div className={styles.headerButtonsContainer}>
              <button className="btn btn-cap logout" onClick={() => logout()}>
                <span className="btn-text">
                  <span className="btn-icon-text">
                    <span>Atsijungti</span>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  generalData: state.dashboardState.generalData,
});

export default connect(mapStateToProps)(Header);
